import { useMemo, useRef, useState } from 'react'
import { useClickAway } from 'react-use'
import { Container, Dropdown, Option } from './styles'
import { IoIosArrowDown } from 'react-icons/io'
import { useUncontrolled } from '../../hooks/use-uncontrolled'

interface IOption {
  value: string | number
  label: string | number
}

interface ITextDropdownProps {
  options: IOption[]

  value?: IOption['value']
  onChange?(value: IOption['value']): void
  defaultValue?: IOption['value']

  disabled?: boolean
  loading?: boolean

  className?: string

  customLabel?(option?: IOption): string
}

const TextDropdown = (props: ITextDropdownProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [displayDropdown, setDisplayDropdown] = useState(false)

  useClickAway(ref, () => {
    setDisplayDropdown(false)
  })

  const [value, onChange] = useUncontrolled({
    value: props.value,
    defaultValue: props.defaultValue,
    finalValue: '',
    onChange: props.onChange,
  })

  const isEmpty = props.options.length === 0

  const selected = useMemo(
    () => props.options.find((option) => option.value === value),
    [value, props.options]
  )

  const toggle = () => {
    if (props.disabled) return
    if (props.loading) return
    if (isEmpty) return

    setDisplayDropdown((state) => !state)
  }

  const renderOptions = () =>
    props.options.map((option) => (
      <Option
        key={option.value}
        onClick={() => {
          onChange(option.value)
        }}
        isSelected={option.value === value}
      >
        <p className="text-dropdown--dropdown-label" title={option.label.toString()}>
          {option.label}
        </p>
      </Option>
    ))

  return (
    <Container onClick={toggle} ref={ref} className={props.className}>
      <button
        disabled={props.disabled || isEmpty || props.loading}
        className="text-dropdown--button-area"
      >
        <div className="wrap">
          <p className="text-dropdown--button-label" title={selected?.label.toString()}>
            {props.customLabel ? props.customLabel(selected) : selected?.label}
          </p>
        </div>

        <IoIosArrowDown size={16} />
      </button>

      {displayDropdown && <Dropdown>{renderOptions()}</Dropdown>}
    </Container>
  )
}

export default TextDropdown
